import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "news-detail" }

import { onMounted } from 'vue'
import { getCommonElementById, getStaticHtml, getOssUrls } from '@/api'
import { findSequences, findSequences2 } from '@/utils'


export default /*@__PURE__*/_defineComponent({
  __name: 'NewsDetail',
  setup(__props) {

onMounted(() => {
  const path: any = JSON.parse(window.sessionStorage.getItem('path') || '{}');
  getCommonElementById({ id: path.query?.id }).then((res: any) => {
    if (res.relatedHtmlId) {
      getStaticHtml({ id: res.relatedHtmlId }).then((html: any) => {
        const resultKeys = findSequences(html);
        const resultSources = findSequences2(html);
        getOssUrls(resultKeys).then((res: any) => {
          resultKeys.forEach((urlKey, i) => {
            html = html.replace(resultSources[i], `source src="${res[i]}`)
          });
          (document.querySelector('.news-detail div') as any).innerHTML = html
        })
      })
    }

  })
  if (document.documentElement && document.documentElement.scrollTop) {
    document.documentElement.scrollTop = 0;
  } else if (document.body) {
    document.body.scrollTop = 0
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", null, null, -1)
  ]))]))
}
}

})